import type { H3Event } from 'h3';

interface UseEnvironment {
    isDev: boolean;
    isProduction: boolean;
    isStaging: boolean;
    isTest: boolean;
}

export function useEnvironment(event?: H3Event): UseEnvironment {
    const config = useRuntimeConfig(event);
    const isDev = config.public.env === 'development';
    const isProduction = config.public.env === 'production';
    const isStaging = config.public.env === 'staging';
    const isTest = config.public.env === 'test';

    return {
        isDev,
        isProduction,
        isStaging,
        isTest,
    };
}
